module.exports = __webpack_public_path__ + "static/media/icon1.c688a7f7.svg";